export enum HealthCheckStatus {
    Pass = 'pass',
    Fail = 'fail',
}